import { useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminPrivate = ({ component: Component, restricted, ...rest }) => {
  const globalState = useSelector((state) => state.AdminReducer);
  const navigate = useNavigate();
  useEffect(() => {
    if (globalState?.isAdminLoggedIn) {
      navigate("/admin-dashboard");
    }
  }, []);

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default AdminPrivate;
